module.exports = __webpack_public_path__ + "static/media/login.7036fe00.mp4";